<div>
    <mat-icon svgIcon="empty" [style.width.px]="width ? width : 190" [style.height.px]="height ? height : 153"></mat-icon>
    <h1>{{'table.empty_data' | translate}}</h1>
    <p class="empty__text">{{'table.be_empty' | translate}}</p>
</div>
